import * as serializer from 'basic-editor-value-serializer';

import HelptapEditor from '../';

export function buildNode(options = {}) {

  return serializer.utilities.node.aiAssistant.buildNode(options);

}

export function insert(editor, path) {

  HelptapEditor.insertParagraph(editor, {}, path);

}

export function toggle(editor) {

  const nodeOptions = buildNode();

  HelptapEditor.setNodeOptions(editor, nodeOptions);

}

export function duplicate(editor, node, nodePath) {

  const clonedNode = HelptapEditor.cloneNode(node);

  HelptapEditor.insertNode(editor, clonedNode, nodePath);

}